import React, { lazy } from 'react'

const SubmitVideoRefPaidPage = lazy(() => import('./SubmitVideoRefPaidPage'))

export { SubmitVideoRefPaidPage }
